import React from "react";

const PrivacyPolicyPage = () => {
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center px-4 pt-28 pb-20 bg-black text-white">
      {/* Background SVG Blobs */}
      <div className="absolute top-0 left-0 w-[600px] h-[600px] opacity-10 z-0">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <path
            fill="#FDE68A"
            d="M44.4,-65.5C55.4,-57.7,59.9,-41.5,65.6,-25.9C71.3,-10.3,78.1,5,76.5,19.6C75,34.2,65.2,47.9,53.1,58.1C41,68.3,26.6,74.8,12.3,73.8C-2,72.8,-16.4,64.4,-31.2,57.4C-46,50.5,-61.2,45.1,-66.4,36.3C-71.6,27.6,-66.8,15.5,-66.7,3.1C-66.7,-9.3,-71.4,-21.9,-66.5,-30.4C-61.6,-39,-47.1,-43.5,-34.3,-51.7C-21.5,-59.9,-10.8,-71.8,3.1,-76.4C17.1,-81,34.1,-78.1,44.4,-65.5Z"
            transform="translate(100 100)"
          />
        </svg>
      </div>

      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] opacity-10 z-0">
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <path
            fill="#FDE68A"
            d="M40.4,-64.2C54.4,-57.8,65.7,-45.8,71.7,-31.4C77.8,-17,78.6,-0.2,75.4,15.3C72.1,30.8,64.9,45,54.1,53.5C43.2,62.1,28.6,64.9,13.5,65.5C-1.7,66.1,-17.2,64.4,-33.3,58.6C-49.4,52.8,-66,42.9,-73.7,28.9C-81.3,14.9,-80.1,-3.2,-73.3,-17.7C-66.6,-32.2,-54.3,-42.9,-41.4,-49.8C-28.5,-56.8,-14.2,-59.9,0.8,-60.8C15.8,-61.8,31.5,-60.6,40.4,-64.2Z"
            transform="translate(100 100)"
          />
        </svg>
      </div>

      {/* Glass Container */}
      <div className="relative z-10 w-full max-w-5xl p-8 sm:p-12 backdrop-blur-lg bg-white/10 border border-white/20 rounded-2xl shadow-xl text-white">
        <h1 className="text-4xl font-bold text-yellow-400 mb-10 text-center">Privacy Policy</h1>

        <div className="space-y-8 text-white/90 leading-relaxed text-sm sm:text-base">
          {[
            {
              title: "Introduction",
              content: `This Privacy Policy describes how Maheshwari Innovative IT Services LLP ("we", "our", "us") collects, uses, shares, protects, or processes your information/personal data through our website and related services.`,
            },
            {
              title: "Collection of Information",
              content: (
                <ul className="list-disc pl-5 space-y-2">
                  <li><b>Personal Info:</b> Name, DOB, address, phone, email, and proofs.</li>
                  <li><b>Sensitive Data:</b> Payment details, biometric data (with consent).</li>
                  <li><b>Usage Data:</b> Behavior, transactions, and preferences.</li>
                </ul>
              )
            },
            {
              title: "Usage of Information",
              content: (
                <ul className="list-disc pl-5 space-y-2">
                  <li>Provide user-requested services.</li>
                  <li>Improve experience, resolve issues.</li>
                  <li>Enable research, security, legal purposes.</li>
                </ul>
              )
            },
            {
              title: "Sharing of Information",
              content: (
                <ul className="list-disc pl-5 space-y-2">
                  <li>With affiliates and service providers.</li>
                  <li>With third-parties for logistics, payments, etc.</li>
                  <li>With legal bodies for compliance.</li>
                </ul>
              )
            },
            {
              title: "Security Precautions",
              content: `We use reasonable security measures. Still, data transmission online has risks. Users must safeguard their credentials.`
            },
            {
              title: "Data Deletion & Retention",
              content: `Users may delete accounts. Some data may be retained as per law or anonymized for research.`
            },
            {
              title: "Your Rights",
              content: `You can access, correct, update, or withdraw consent regarding your data. This may affect service access.`
            },
            {
              title: "Consent",
              content: `By using our services, you consent to our privacy practices outlined here.`
            },
            {
              title: "Policy Updates",
              content: `We may update our policy. Please review it regularly.`
            },
          ].map(({ title, content }) => (
            <section key={title}>
              <h2 className="text-xl font-semibold text-yellow-300 mb-2">{title}</h2>
              <p className="text-white/90">{content}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
